import { Pagination, SortedTable, Tab, TableBar } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';
import { Direction, usePagination } from '~src/main/hooks/usePagination';

import { useShipmentListFilter } from './filters/useShipmentListFilter';
import { GroupType, Groups, MAX_GROUP_SIZE } from './groups';

interface Props {
  shipmentsCountData:
    | {
        groups: {
          group: GroupType;
          count: number;
        }[];
      }
    | undefined;
}

export function ListTableBar({ shipmentsCountData }: Props) {
  const { filtering, setFiltering } = useShipmentListFilter();
  const { direction, setDirection } = usePagination();
  const { t } = useTranslation();

  return (
    <TableBar sticky>
      <Tab.Root value={filtering.group}>
        <Tab.List>
          {Groups.map(tab => {
            const count = shipmentsCountData?.groups.find(g => g.group === tab.group)?.count ?? 0;

            return (
              <Tab.Item
                onClick={() => setFiltering(p => ({ ...p, group: tab.group }))}
                disabled={count === 0}
                value={tab.group}
                key={tab.group}
              >
                <Tab.Label>{t(tab.label)}</Tab.Label>
                <Tab.Counter>{count === MAX_GROUP_SIZE ? `${count}+` : count}</Tab.Counter>
              </Tab.Item>
            );
          })}
        </Tab.List>
      </Tab.Root>

      <SortedTable.Provider
        onSortValueChange={sortValue => setDirection(sortValue.sort as Direction)}
        sortValue={{ name: direction, sort: direction }}
      >
        <Pagination sortName={direction} />
      </SortedTable.Provider>
    </TableBar>
  );
}
